import React from "react";
import { Community } from "../utils/commsParser";
import { LOGOS_TO_SHOW } from "./community-onboarding-loading";
interface CommunityLogoProps {
    size: number;
    margin: number;
    selectedCommunties: Community[];
}

const CommunityLogo: React.FC<CommunityLogoProps> = ({
    size,
    selectedCommunties,
    margin,
}) => {
    const sliced = selectedCommunties.slice(
        1,
        Math.min(selectedCommunties?.length, LOGOS_TO_SHOW)
    );
    return (
        <div className="flex">
            <img
                src={selectedCommunties[0]?.logoUrl}
                className="rounded-full border-4 border-white"
                style={{
                    height: `${size}px`,
                    width: `${size}px`,
                }}
            />

            {sliced?.map((comm) => (
                <img
                    key={comm.id}
                    src={comm?.logoUrl}
                    className="rounded-full border-4 border-white"
                    style={{
                        marginLeft: `${margin}px`,
                        height: `${size}px`,
                        width: `${size}px`,
                    }}
                />
            ))}
        </div>
    );
};

export default CommunityLogo;
